// constants
import { DebateActionTypes } from './constants';

export type DebateActionType = {
    type:
        | DebateActionTypes.API_RESPONSE_SUCCESS
        | DebateActionTypes.API_RESPONSE_ERROR
        | DebateActionTypes.RESET
        | DebateActionTypes.REBATE_RECEVIED
        | DebateActionTypes.REBATE_PAID
        | DebateActionTypes.UPD_REBATE_PAID
        | DebateActionTypes.UPDREBATE_RECEVIED;
    payload: {} | string;
};

type InvoiceData = {
    name: string;
};

// common success
export const debateApiResponseSuccess = (actionType: string, data: InvoiceData | {}): DebateActionType => ({
    type: DebateActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const debateApiResponseError = (actionType: string, error: string): DebateActionType => ({
    type: DebateActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addRebateRece = (
    entrydate,
    accountid,
    description,
    totalamount,
    reference,
    cashcounterid,
    cashreceived,
    bankid,
    bankreceived,
    transtype,
    voucherdetdata
) => ({
    type: DebateActionTypes.REBATE_RECEVIED,
    payload: {
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashreceived,
        bankid,
        bankreceived,
        transtype,
        voucherdetdata,
    },
});

export const addRebatePaid = (
    entrydate,
    accountid,
    description,
    totalamount,
    reference,
    cashcounterid,
    cashpaid,
    bankid,
    bankpaid,
    transtype,
    voucherdetdata
) => ({
    type: DebateActionTypes.REBATE_PAID,
    payload: {
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashpaid,
        bankid,
        bankpaid,
        transtype,
        voucherdetdata,
    },
});

export const updRebateRece = (
    id,
    entrydate,
    accountid,
    description,
    totalamount,
    reference,
    cashcounterid,
    cashreceived,
    bankid,
    bankreceived,
    transtype,
    voucherdetdata
) => ({
    type: DebateActionTypes.UPDREBATE_RECEVIED,
    payload: {
        id,
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashreceived,
        bankid,
        bankreceived,
        transtype,
        voucherdetdata,
    },
});

export const updRebatePaid = (
    id,
    entrydate,
    accountid,
    description,
    totalamount,
    reference,
    cashcounterid,
    cashpaid,
    bankid,
    bankpaid,
    transtype,
    voucherdetdata
) => ({
    type: DebateActionTypes.UPD_REBATE_PAID,
    payload: {
        id,
        entrydate,
        accountid,
        description,
        totalamount,
        reference,
        cashcounterid,
        cashpaid,
        bankid,
        bankpaid,
        transtype,
        voucherdetdata,
    },
});


export const resetRebate = (): DebateActionType => ({
    type: DebateActionTypes.RESET,
    payload: {},
});
